import styled from "styled-components"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  color: ${(props) => props.theme.a_color_gradients.a_light};
`

const ActuTaxo = styled.span`
  & > a {
    color: ${(props) => props.theme.a_color_gradients.a_light};
    text-decoration: none;
    font-weight: 600;
  }
`

const ActuTitle = styled.h1`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`

const ActualiteFooterContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  font-weight: bold;
  & a::before {
    background-color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`

const GridDate = styled.p`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

export {
  AdditionalInfos,
  ActuTaxo,
  ActuTitle,
  ActualiteFooterContainer,
  GridDate,
}
